import { z } from 'zod'
import { Id } from './primitives'

export const LIVE_EVENT_KINDS = ['conversation', 'suggestion', 'inbox'] as const
export type LiveEventKind = (typeof LIVE_EVENT_KINDS)[number]

export const LIVE_CHANGE_EVENT = 'change'
export const LIVE_READY_EVENT = 'ready'
export const LIVE_HEARTBEAT_EVENT = 'heartbeat'
export const LIVE_HEARTBEAT_MS = 25_000

export const LiveEvent = z.object({ kind: z.enum(LIVE_EVENT_KINDS), conversationId: Id })
export type LiveEvent = z.infer<typeof LiveEvent>
